import React from "react";
import { usePromiseTracker } from "react-promise-tracker";
import 'antd/lib/spin/style/css';
import '../../resources/css/Loader.css';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

export const Loading= ()  =>
{
    const antIcon = <LoadingOutlined style={{ fontSize: 32, color: '#f26a21' }} spin />;
    const { promiseInProgress } = usePromiseTracker();
    return promiseInProgress &&
        <div className="loading-container">
            <div id="circle">
                <Spin indicator={antIcon} tip={'Cargando...'}/>
            </div>
        </div>;
};